import React, { createContext, useContext, useEffect, useState } from "react";
import { io } from "socket.io-client";

const SocketContext = createContext(null);

export function SocketProvider({ children }) {
  const [socket, setSocket] = useState(null);

  useEffect(() => {
    // CRA uses process.env.REACT_APP_API_URL
    const backendURL = process.env.REACT_APP_API_BASE || "https://studio-kosmos-backend-production.up.railway.app";

    const newSocket = io(backendURL, {
      transports: ["websocket"],
    });

    setSocket(newSocket);

    newSocket.on("connect", () => {
      console.log("✅ Connected to WebSocket server:", newSocket.id);
    });

    newSocket.on("disconnect", () => {
      console.warn("⚠️ Disconnected from WebSocket server");
    });

    return () => {
      newSocket.disconnect();
    };
  }, []);

  return (
    <SocketContext.Provider value={socket}>{children}</SocketContext.Provider>
  );
}

export function useSocket() {
  return useContext(SocketContext);
}
